const template = document.createElement("template");
template.innerHTML = `
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body"></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
`;
export default () => {
    var _a;
    return (_a = template.content.firstElementChild) === null || _a === void 0 ? void 0 : _a.cloneNode(true);
};
//# sourceMappingURL=element.js.map